import { useState,useEffect } from "react";
import {userservices} from '../../services/userServices';
import {rolepermissionServices} from '../../services/rolepermissionServices';

const AssignRole = () =>{

    const [initialvalue,setValues] = useState({}); 
    const [roles,setroles] = useState([]);
    const [users,setusers] = useState([]); 
      
    

    useEffect(()=>{
        getusers();
        getroles();
    },[])


    function getusers(){
        userservices.getusers().then((response)=>{
             if(response.status == 200){    
                setusers(response.data.data);
             }else{
                setusers([]);  
             }
        }).catch((error)=>{
            setusers([]);  
             console.log(error);
        })   
    }   
    
    function getroles(){
        rolepermissionServices.getroles().then((response)=>{
            if(response.status == 200){    
               setroles(response.data.data);
            }else{
                setroles([]);  
            }
       }).catch((error)=>{
            setroles([]);  
            console.log(error);
       }) 
    }

    function displayusers(){
        let temparr = [];
        users.forEach((value)=>{    
            temparr.push(<option value={value.id}>{value.name}</option>);   
        })

        return temparr;
    } 


    const handlechanges = (e) =>{
        setValues((prevdata)=>{
              return{
                 ...prevdata,
                 [e.target.name]:e.target.value
              }  
        });
    } 

    const assignrole  = (e) => {
        e.preventDefault();

    }

    return(
         <>
              <div className="card">
                <form onSubmit={(e)=>assignrole(e)}>
                    <div class="row">
                        <div className="col-md-3"> 
                        <div class="form-group">
                            <label for="name">Select User</label>
                            <select name="user" className="form-control">
                                {displayusers()}
                            </select>
                        </div>
                        </div>

                        <div className="col-md-3"> 
                        <div class="form-group">
                            <label for="name">Select Role</label>
                            <select name="role" className="form-control">
                                {/* <option></option> */}
                            </select>
                        </div>
                        </div>
                        
                        
                        <div className="col-md-3">
                        <div style={{marginTop:'26px'}}></div> 
                        <div class="form-group">
                            <button className="btn btn-success btn-round" type="submit">Save</button>
                        </div>
                        </div>
                        
                        </div>
                    </form>
                    </div>            
         </>
    );   
} 

export default AssignRole;